import { PageHeader } from '@/components/ui/PageHeader'
import { SectionLayout } from '../shared-components/SectionLayout'
import { PlatformBreadcrumbs } from './PlatformBreadcrumbs'
import { RedisMenu } from './RedisMenu'

export function PlatformHomePage() {
  return (
    <>
      <PageHeader className="pr-3" title={<PlatformBreadcrumbs title="Details" />}>
        <RedisMenu />
      </PageHeader>
      <SectionLayout>Details Page</SectionLayout>
    </>
  )
}
